import React, { useEffect } from "react";
import styles from "./CollectionProductsList.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Products from "./Products";
import { getCollectionProducts } from "../../Firebase/firebaseDatabase";

const CollectionProductsList = () => {

  return (
    <>
      <div className={styles.section}>
        <Products />
      </div>
      <TooltipGlodal />
    </>
  );
};

export default CollectionProductsList;
